import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class EncodingMSPService {
	constructor() {}

	decodeHTML(html: string): string {
		const txt = document.createElement('textarea');
		txt.innerHTML = html;
		return txt.value;
	}
}
